var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-application ls-application--is-ltr",attrs:{"id":"app","data-uzair-theme":_vm.isDarkMode ? 'dark' : 'light'}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }